import { ERROR, READY, useVisualState } from '../../../../hooks/useVisualState'
import { Form, FormBand } from '../../../../components/Form/Form'
import { oldGet, oldPost } from '../../../../helpers/requestOld'
import { useCallback, useEffect, useRef, useState } from 'react'

import Button from '../../../../components/Button/Button'
import { DYNAMIC_FIELDS } from '../../../../helpers/constants'
import GenericErrorModal from '../../../../modules/GenericErrorModal/GenericErrorModal'
import Modal from '../../../../components/Modal/Modal'
import ModalContent from '../../../../components/Modal/ModalContent'
import ModalFooter from '../../../../components/Modal/ModalFooter'
import ModalHeader from '../../../../components/Modal/ModalHeader'
import React from 'react'
import TagsInput from '../../../../components/TagsInput/TagsInput'
import { closeEvent } from '../../../../components/Modal/ModalEvents'
import t from '../../../../helpers/i18n'
import { useParams } from 'react-router-dom'

const filterOutputPositions = (text) => {
  return DYNAMIC_FIELDS.includes(text) ? text : false
}

const filterInputPositions = (values) => {
  if (!values) return ''
  return values.join(',')
}

const OldDynamicFieldsFormModal = ({ onCloseRequested }) => {
  const [formValid, setFormValid] = useState(false)
  const [error, setError] = useState()
  const dynamicFieldsData = useRef()
  const [[categoryState, category], setCategory] = useVisualState()
  const { categoryId } = useParams()

  const handleSaveDynamicFields = useCallback(() => {
    oldPost('/cm/categories/' + categoryId + '/dynamic_fields', dynamicFieldsData.current)
      .then(() => onCloseRequested())
      .catch(error => setError(error))
  }, [categoryId, onCloseRequested])

  useEffect(() => {
    oldGet('/cm/categories/' + categoryId)
      .then(response => setCategory(READY, response))
      .catch(error => setCategory(ERROR, error))
  }, [setCategory, categoryId])

  return (
    <div>
      {categoryState === READY &&
        <Modal onCloseRequested={onCloseRequested}>
          <ModalHeader title={t('Edit category dynamic fields')} />
          <Form data={dynamicFieldsData} onValidityChange={setFormValid}>
            <ModalContent>
              <FormBand text={t("Dynamic Fields")} />
              <TagsInput
                name="player_dynamic_fields"
                label={t('Additional fields for players')}
                initialValue={DYNAMIC_FIELDS.filter(row => category.player_dynamic_fields && category.player_dynamic_fields.includes(row))}
                filterOutput={filterOutputPositions}
                filterInput={filterInputPositions}
                options={DYNAMIC_FIELDS}
                />
              <TagsInput
                name="technical_staff_dynamic_fields"
                label={t('Additional fields for technical staff')}
                initialValue={DYNAMIC_FIELDS.filter(row => category.technical_staff_dynamic_fields && category.technical_staff_dynamic_fields.includes(row))}
                filterOutput={filterOutputPositions}
                filterInput={filterInputPositions}
                options={DYNAMIC_FIELDS}
                />
            </ModalContent>
          </Form>
          <ModalFooter>
            <div>
              <Button onClick={event => closeEvent(event.currentTarget, false)} label={t("Cancel")} />
            </div>
            <div>
              <Button disabled={!formValid} onClick={handleSaveDynamicFields} label={t("Save")} />
            </div>
          </ModalFooter>
          {error && <GenericErrorModal error={error} i18nPrefix="OldDynamicFieldsFormModal" onCloseRequested={() => setError(false)} />}
        </Modal>
      }
    </div>
  )
}

export default OldDynamicFieldsFormModal